<template>
<CheckMTGBalToGLComp/>
</template>

<script>
import CheckMTGBalToGLComp from '../../../components/Gl/CheckMTGBalToGL/CheckMTGBalToGL.vue';

export default {
  components: {
    CheckMTGBalToGLComp,
  },
};

</script>
